import React from "react";
import styled from "styled-components";
import { H3, Modal } from "notes";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

export const DonationModal = ({ open, setOpen, children }) => {
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_TOKEN);
  return (
    <Wrapper size="small" open={open} setOpen={setOpen}>
      <Elements stripe={stripePromise}>
        <H3 style={{ margin: 0 }}>Donate</H3>
        {children}
      </Elements>
    </Wrapper>
  );
};

const Wrapper = styled(Modal)``;
